import { EntityInterface } from '@app/shared/model/entity/interfaces/entityInterface.model';
import { AbstractTableComponent } from './abstractTableComponent';
import { Directive } from '@angular/core';

@Directive()
export abstract class AbstractNoEntityTableComponent extends AbstractTableComponent {

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    getDetailComponentClass(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        entity: string)
    {
        return null;
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getDetailModalSize(entity: string): 'sm' | 'lg' | 'xl' {
        return null;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onCreate(entity: string, element: EntityInterface): void {
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onUpdate(entity: string, element: EntityInterface): void {
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onDelete(entity: string, pk: string): void {
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onFindAll(entity: string, elements: EntityInterface[]): void {
    }
}
